import '../polyfills/closest';

// Returns true if the field is actually visible
export function isFieldVisible(field){
  return !exports.isVashonQuestionBlocked(field);
}

// Returns true if a vashon question is blocked
export function isVashonQuestionBlocked(field){
  if (typeof field.closest !== 'function') { return false; }
  const question = field.closest('.vashon-question');
  if (question == null) { return false; }
  return question.classList.contains('vashon-phrase__question--blocked');
}

export default isFieldVisible;
